import * as Sentry from "@sentry/browser";

const SENTRY_DSN = process.env.SENTRY_DSN || "";
const SENTRY_ENVIRONMENT =
  process.env.SENTRY_ENV || process.env.NODE_ENV || "production";

let initialized = false;

export function initMonitoring() {
  if (initialized || !SENTRY_DSN) {
    return;
  }

  Sentry.init({
    dsn: SENTRY_DSN,
    environment: SENTRY_ENVIRONMENT,
    attachStacktrace: true,
  });

  initialized = true;
}

export function isMonitoringEnabled() {
  return Boolean(SENTRY_DSN);
}

export function setMonitoringUser(user: { id: string; username?: string }) {
  if (!isMonitoringEnabled()) {
    return;
  }

  Sentry.setUser({
    id: user.id,
    username: user.username,
  });
}

export function setMonitoringContext(context: {
  page: "call" | "review";
  appointmentId?: string;
  participantRole?: string;
}) {
  if (!isMonitoringEnabled()) {
    return;
  }

  Sentry.setTag("page", context.page);

  if (context.appointmentId) {
    Sentry.setTag("appointment_id", context.appointmentId);
  }

  if (context.participantRole) {
    Sentry.setTag("participant_role", context.participantRole);
  }

  Sentry.setContext("telemedicina", context);
}

export function captureMonitoringMessage(
  message: string,
  level: Sentry.SeverityLevel = "info",
  extra?: Record<string, unknown>,
) {
  if (!isMonitoringEnabled()) {
    return;
  }

  Sentry.withScope((scope) => {
    if (extra) {
      scope.setContext("details", extra);
    }

    scope.setLevel(level);
    Sentry.captureMessage(message);
  });
}

export function captureMonitoringException(
  error: unknown,
  extra?: Record<string, unknown>,
) {
  if (!isMonitoringEnabled()) {
    return;
  }

  Sentry.withScope((scope) => {
    if (extra) {
      scope.setContext("details", extra);
    }

    Sentry.captureException(error);
  });
}
